import { createContext } from 'react';
import { FirestoreUser, Invitation } from 'generated/graphql';
import { InvitationType } from "../constant/InvitationType.enum";

export type UsersContextType = {
    removeUser: (userId: string) => void;
    removeInvitation: (invitationId: string) => void;
    updateInvitations: (invitationId: string, newInvitation: Invitation[]) => void;
    searchFilters: any[];
    searchInput: string;
    setSearchInput: React.Dispatch<React.SetStateAction<string>>;
    handleOnSearchBarChange: (chips: string[]) => void;
    usersTable: FirestoreUser[];
    invitationsTable: Invitation[];
    users: FirestoreUser[];
    invitations: Invitation[];
    selectedInvitationType: string;
    setSelectedInvitationType: React.Dispatch<React.SetStateAction<InvitationType>>;
    addInvitation: (newInvitation: Invitation[]) => void;
    addUser: (newUser: FirestoreUser) => void;
    loadingUsers: boolean;
    loadingInvites: boolean;
};

const UserContext = createContext<UsersContextType | null>(null);

export default UserContext;
